import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';

const HR_FAQ_URL = 'https://skydrive3m.sharepoint.com/sites/hrhelp/SitePages/Ask-HR-AI-Assistant.aspx';

interface LegalDisclaimersProps {
  showNote?: boolean;
}

export function LegalDisclaimers({ showNote = false }: LegalDisclaimersProps) {
  const ragChatType = useSelector((state: RootState) => state.chatMode.ragChatType);
  const isHR = ragChatType === 'HR';

  return (
    <div className="w-full text-[0.45rem] sm:text-[0.5rem] md:text-[0.55rem] lg:text-[0.6rem] xl:text-[0.65rem] text-[var(--color-text)] text-center max-w-[100vw] leading-tight select-none pointer-events-none px-1 py-0.5 relative" style={{ zIndex: 15 }}>
      <div>
        <strong>Important:</strong> Ensure you adhere to 3M's Global Responsible AI Use Policy and do not use any highly sensitive data.
        <br />
        {isHR
          ? <>For matters that are subject to 3M legal hold, retain any final 3M Knowledge output. 3M Knowledge provides general HR information only. It does not include benefit plan documents or all company, country, or local policies or procedures. Official 3M standards, policies, procedures, plans, collective bargaining agreements, other local employment documents, and local requirements always take precedence. Ask HR inquiries may be used for quality assurance and service improvement purposes, including user location, employee type, question, answer and feedback.
              {/* Parent sets pointer-events:none for the whole disclaimer, so the link must opt back in. */}
              <a
                href={HR_FAQ_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
                style={{ pointerEvents: 'auto' }}
              >
                &nbsp;For more information, access Ask HR AI Assistant FAQ
              </a>. 
            </>
          : <>For matters that are subject to 3M legal hold, retain any final 3M Navigator output.</>
        }
        {showNote && (
          <div>
            <br />
            <strong>Note:</strong> Generative AI agents may produce inaccurate information about people, places, or facts.
          </div>
        )}
      </div>
    </div>
  );
}